import { BroadcastChannels } from 'shared/constants/broadcast/channels'
import {
  AppFocusHeartbeatMessage,
  NotificationsBroadcastMessages
} from 'shared/constants/broadcast/notifications'
import { FEATURE_FLAGS } from 'shared/constants/featureFlags'
import { logger } from 'shared/services/logger'
import { postMessage } from 'shared/utils/broadcastChannel'
import { getContainerTabId } from 'shared/utils/getContainerTabId'

export const broadcastAppFocusHeartbeat = (
  appIdFocused: string | null
): void => {
  const message: AppFocusHeartbeatMessage = {
    type: NotificationsBroadcastMessages.APP_FOCUS_HEARTBEAT,
    payload: {
      tabId: getContainerTabId(),
      appIdFocused,
      at: new Date().toISOString()
    }
  }

  postMessage(BroadcastChannels.NOTIFICATIONS, message)

  if (FEATURE_FLAGS.APP_FOCUS_HEARTBEAT_DEV_LOGGING_ENABLED) {
    logger.debug('ui.app_focus_heartbeat', { ...message.payload })
  }
}
